import React, { PropTypes, Component } from 'react'
import { translate } from 'react-i18next'
import R from 'ramda'
import Promise from 'bluebird'
import Grid, { Half } from 'grid-styled'
import styled from 'styled-components'
import { Metrics, Fonts, Colors } from '../../Themes'
import { validateInput } from '../../Utils/Validations'
import {
  searchCategories,
  searchCities,
  searchCountries,
  searchContinents
} from '../../sources/SearchSource'
import {
  searchUsers,
  searchProperties,
  updateProperty,
  deleteProperty,
  createProperty
} from '../../sources/AdminSource'
import { addOrRemoveObjectFromList } from '../../Utils'
import CardContainer from '../../components/CardContainer'
import AdminNavbar from '../../components/AdminNavbar'
import Input from '../../components/Input'
import ThemeContainer from '../../components/ThemeContainer'
import Dropdown from '../../components/Dropdown'
import SearchableDropdown from '../../components/SearchableDropdown'
import Switch from '../../components/Switch'
import List from '../../components/List'
import ListItem from '../../components/ListItem'
import BackArrow from '../../svg-icons/BackArrow'
import Avatar from '../../components/Avatar'
import Add from '../../svg-icons/Add'
import UploadPicture from '../../components/UploadPicture'
import Textarea from '../../components/Textarea'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'
import DialogModal from '../../components/Modal/DialogModal'
import { propertyDefault } from '../../Utils/Defaults'

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.larger};
`

const Title = styled.div`
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Label};
`

const CustomHalf = styled(Half)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
  .switch {
    float: right;
  }

  span {
    ${Fonts.style.Text};
  }
`

const CustomGrid = styled(Grid)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
  span {
    ${Fonts.style.Text};
  }
`

const UserSearchBox = styled.div``

const CustomList = styled(List)`
  margin-top: ${Metrics.margins.medium};
  border: ${Metrics.borders.default};
  border-radius: ${Metrics.borders.defaultRadius};
  height: 150px;
  max-height: none;
`

const BackArrowContainer = styled.div`
  margin-top: ${Metrics.margins.larger};
  span {
    ${Fonts.style.Header};
    margin-left: ${Metrics.margins.medium};
  }

  svg {
    cursor: pointer;
  }
`

const UploadButton = styled.div`
  background: ${Colors.lightGrey};
  height: 137px;
  width: 137px;
  padding: ${Metrics.margins.larger};
  ${Fonts.style.Input};
  color: ${Colors.white};
  text-transform: capitalize;
  text-align: center;
  cursor: pointer;

  svg {
    margin: 0 auto;
    margin-bottom: 20px;
    display: block;
    #plus-icon {
      fill: white;
    }
  }
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

class AdminPropertyDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      create: false,
      property: null,
      categories: [],
      countries: [],
      continents: [],
      cities: [],
      searchCountry: '',
      searchContinent: '',
      searchCity: '',
      searchUsersToAdd: '',
      searchUsersToRemove: '',
      authorizedUsers: [],
      searchedUsers: [],
      errors: {
        title: '',
        city: '',
        realLocation: '',
        description: '',
        category: '',
        yield: '',
        price: '',
        country: '',
        continent: '',
        imageUpload: ''
      },
      modalType: '',
      modalMessage: ''
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSwitch = this.handleSwitch.bind(this)
    this.handleSearchLocation = this.handleSearchLocation.bind(this)
    this.handleSelectLocation = this.handleSelectLocation.bind(this)
    this.handleDropdownSelect = this.handleDropdownSelect.bind(this)
    this.handleSearchUser = this.handleSearchUser.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.filterUsers = this.filterUsers.bind(this)
    this.uploadPicture = this.uploadPicture.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.handleSearchableDropdownBlur = this.handleSearchableDropdownBlur.bind(
      this
    )
    this.validateForm = this.validateForm.bind(this)
    this.handleValidate = this.handleValidate.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleUploadImageError = this.handleUploadImageError.bind(this)
  }

  componentWillMount () {
    const { params } = this.props

    Promise.all([
      searchUsers({ limit: 10, sort: 'name ASC' }),
      searchCategories(),
      params.id !== 'new' ? searchProperties({ id: params.id }) : null
    ])
      .spread((usersResponse, categoriesResponse, propertyResponse) => {
        let property = propertyResponse ? propertyResponse.data : null
        this.setState({
          create: params.id === 'new',
          searchedUsers: property
            ? R.differenceWith(
                (userA, userB) => userA.id === userB.id,
                usersResponse.data,
                property.usersHaveAccess
              )
            : usersResponse.data,
          categories: categoriesResponse.data,
          property: property || R.clone(propertyDefault),
          authorizedUsers: property ? property.usersHaveAccess : [],
          searchCity: property ? property.city.city : '',
          searchCountry: property ? property.country.name : '',
          searchContinent: property ? property.continent.name : ''
        })
      })
      .catch(console.error)
  }

  handleChange (event, key) {
    const { property } = this.state
    property[key] = event.target.value
    this.setState({ property })
  }

  handleSubmit () {
    const { property, create } = this.state
    const updatedProperty = property
    if (this.validateForm()) {
      updatedProperty.city = updatedProperty.city.id
      updatedProperty.country = updatedProperty.country.id
      updatedProperty.continent = updatedProperty.continent.id
      updatedProperty.category = updatedProperty.category.id
      if (create) {
        createProperty(updatedProperty)
          .then(response => this.toggleModal({ type: 'success' }))
          .catch(error => {
            console.log(error)
            this.toggleModal({ type: 'error' })
          })
      } else {
        updateProperty(updatedProperty)
          .then(response => {
            this.setState({ property: response.data }, () =>
              this.toggleModal({ type: 'success' })
            )
          })
          .catch(error => {
            console.log(error)
            this.toggleModal({ type: 'error' })
          })
      }
    }
  }

  handleDelete () {
    const { router } = this.props
    deleteProperty(this.state.property.id)
      .then(response => router.replace('/admin'))
      .catch(error => {
        console.log(error)
        this.toggleModal({ type: 'error' })
      })
  }

  handleSwitch (key) {
    const { property } = this.state
    property[key] = !property[key]
    this.setState({ property })
  }

  handleSearchLocation (event, key) {
    const value = event.target.value
    switch (key) {
      case 'continent':
        this.setState({ searchContinent: value }, () => {
          searchContinents({ where: { name: { startsWith: value } } })
            .then(response => this.setState({ continents: response.data }))
            .catch(error => console.log(error))
        })
        break
      case 'country':
        this.setState({ searchCountry: value }, () => {
          searchCountries({ where: { name: { startsWith: value } } })
            .then(response => this.setState({ countries: response.data }))
            .catch(error => console.log(error))
        })
        break
      case 'city':
        this.setState({ searchCity: value }, () => {
          searchCities({ where: { city: { startsWith: value } } })
            .then(response => this.setState({ cities: response.data }))
            .catch(error => console.log(error))
        })
        break
      default:
        break
    }
  }

  handleSelectLocation (el, key) {
    const { property, errors } = this.state
    property[key] = el
    property.latlng = {
      latitude: 0,
      longitude: 0
    }

    errors[key] = ''

    this.setState({
      property,
      errors,
      searchCity: property.city ? property.city.city : '',
      searchCountry: property.country ? property.country.name : '',
      searchContinent: property.continent ? property.continent.name : ''
    })
  }

  handleSearchUser (event) {
    const value = event.target.value
    this.setState({ searchUsersToAdd: value }, () => {
      searchUsers({
        or: [
          { email: { startsWith: value } },
          { firstName: { startsWith: value } },
          { lastName: { startsWith: value } }
        ],
        sort: 'name ASC',
        limit: 30
      })
        .then(response => {
          const searchedUsers = R.differenceWith(
            (userA, userB) => userA.id === userB.id,
            response.data,
            this.state.authorizedUsers
          )
          this.setState({ searchedUsers })
        })
        .catch(error => console.log(error))
    })
  }

  handleDropdownSelect (el, key) {
    const { errors, property } = this.state
    property[key] = el
    errors[key] = ''
    this.setState({ property, errors })
  }

  filterUsers (event) {
    const { property } = this.state
    let users = property.usersHaveAccess
    const value = event.target.value
    if (value.length !== 0) {
      const cond = d =>
        R.or(
          R.test(RegExp(value.toLowerCase()), d.firstName.toLowerCase()),
          R.test(RegExp(value.toLowerCase()), d.lastName.toLowerCase())
        )
      users = R.filter(cond, users)
    }
    this.setState({ authorizedUsers: users, searchUsersToRemove: value })
  }

  handleSelectUser (el) {
    const property = R.clone(this.state.property)
    property.usersHaveAccess = addOrRemoveObjectFromList(
      property.usersHaveAccess,
      el
    )
    const searchedUsers = R.sort(
      R.descend(R.prop('firstName')),
      addOrRemoveObjectFromList(this.state.searchedUsers, el)
    )
    this.setState({
      property,
      searchedUsers,
      authorizedUsers: property.usersHaveAccess
    })
  }

  uploadPicture (file, result) {
    const { property, errors } = this.state
    property.picture = {
      file,
      result
    }
    this.setState({ property, errors: { ...errors, imageUpload: '' } })
  }

  handleSearchableDropdownBlur () {
    const { property } = this.state
    this.setState({
      searchCity: property.city ? property.city.city : '',
      searchCountry: property.country ? property.country.name : '',
      searchContinent: property.continent ? property.continent.name : ''
    })
  }

  toggleModal ({ type, message }) {
    this.setState({ modalType: type, modalMessage: message })
  }

  handleValidate (name, value, errors) {
    let newErrors = validateInput(name, value, errors)
    this.setState({ errors: newErrors })
  }

  validateForm () {
    let { errors, property } = this.state
    const requiredFields = document.querySelectorAll('[required]')
    let valid = true
    for (var k = 0; k < requiredFields.length; k++) {
      const name = requiredFields[k].id || requiredFields[k].name
      errors = validateInput(name, property[name], errors)
      valid = valid && errors[name] === ''
    }
    this.setState({ errors })
    return valid
  }

  handleUploadImageError (error) {
    const { errors, property } = this.state

    const update = {
      errors: { ...errors, imageUpload: error },
      property: { ...property, picture: null }
    }
    this.setState(update)
  }

  mainInfoCard () {
    const { t } = this.props
    const { property, categories, errors } = this.state

    return (
      <CustomCardContainer title={t('Main Info')}>
        <CustomHalf noPadLeft noPadTop>
          <Input
            required
            title={t('Name')}
            handleChange={event => this.handleChange(event, 'title')}
            value={property.title}
            placeholder={t('Insert the property name')}
            error={errors['title']}
            name='title'
            handleBlur={event =>
              this.handleValidate('title', property.title, errors)}
          />
        </CustomHalf>
        <CustomHalf noPadRight noPadTop>
          <Title>{t('Property Type')}*</Title>
          <Dropdown
            handleSelect={el => this.handleDropdownSelect(el, 'category')}
            accessor={d => d.name}
            title={t('Property Type')}
            options={categories}
            selectedOption={property.category}
            placeholder={t('Select the property type')}
            name='category'
            required
            handleBlur={event =>
              this.handleValidate('category', property.category, errors)}
            error={errors['category']}
          />
        </CustomHalf>
        <CustomHalf noPadLeft>
          <Title>{t('Portfolio')}</Title>
          <Dropdown
            accessor={d => {
              return d ? t('Yes') : t('No')
            }}
            handleSelect={el => this.handleDropdownSelect(el, 'portfolio')}
            selectedOption={property.portfolio}
            options={[ true, false ]}
            placeholder={t('Does this property have portfolio?')}
          />
        </CustomHalf>
        <CustomHalf noPadRight>
          <Input
            required
            title={t('Price €')}
            handleChange={event => this.handleChange(event, 'price')}
            value={`${property.price}`}
            placeholder={t('Insert Price in EUR')}
            error={errors['price']}
            name='price'
            handleBlur={event =>
              this.handleValidate('price', property.price, errors)}
          />
        </CustomHalf>
        <CustomHalf noPadLeft>
          <Input
            title={t('Usable Area (m2)')}
            handleChange={event => this.handleChange(event, 'usableArea')}
            value={`${property.usableArea}`}
            placeholder={t('Insert Land Area')}
            name='usableArea'
          />
        </CustomHalf>
        <CustomHalf noPadRight>
          <Input
            title={t('Land Area (m2)')}
            handleChange={event => this.handleChange(event, 'area')}
            value={`${property.area}`}
            placeholder={t('Insert Usable Area')}
            name='area'
          />
        </CustomHalf>
      </CustomCardContainer>
    )
  }

  addressCard () {
    const { t } = this.props
    const {
      property,
      countries,
      continents,
      cities,
      searchCity,
      searchCountry,
      searchContinent,
      errors
    } = this.state

    return (
      <CustomCardContainer title={t('Address')}>
        <CustomGrid xs={1 / 3} noPadLeft noPadTop>
          <Title>{t('Continent')}*</Title>
          <SearchableDropdown
            required
            options={continents}
            placeholder={t('Search for continents')}
            handleSearch={event =>
              this.handleSearchLocation(event, 'continent')}
            handleSelect={el => this.handleSelectLocation(el, 'continent')}
            value={searchContinent}
            accessor={d => d.name}
            handleBlur={this.handleSearchableDropdownBlur}
            error={errors['continent']}
            inputName='continent'
            handleInputBlur={event =>
              this.handleValidate('continent', property.continent, errors)}
          />
        </CustomGrid>
        <CustomGrid xs={1 / 3} noPadTop>
          <Title>{t('Country')}*</Title>
          <SearchableDropdown
            required
            options={countries}
            placeholder={t('Search for continents')}
            handleSearch={event => this.handleSearchLocation(event, 'country')}
            handleSelect={el => this.handleSelectLocation(el, 'country')}
            value={searchCountry}
            accessor={d => d.name}
            handleBlur={this.handleSearchableDropdownBlur}
            error={errors['country']}
            handleInputBlur={event =>
              this.handleValidate('country', property.country, errors)}
            inputName='country'
          />
        </CustomGrid>
        <CustomGrid xs={1 / 3} noPadRight noPadTop>
          <Title>{t('City')}*</Title>
          <SearchableDropdown
            required
            placeholder={t('Search for cities')}
            options={cities}
            handleSearch={event => this.handleSearchLocation(event, 'city')}
            handleSelect={el => this.handleSelectLocation(el, 'city')}
            value={searchCity}
            accessor={d => d.city}
            handleBlur={this.handleSearchableDropdownBlur}
            error={errors['city']}
            inputName='city'
            handleInputBlur={event =>
              this.handleValidate('city', property.title, errors)}
          />
        </CustomGrid>

        <CustomGrid noPadLeft noPadRight>
          <Input
            required
            title={t('Address')}
            handleChange={event => this.handleChange(event, 'realLocation')}
            value={property.realLocation}
            placeholder={t('Insert the Address of property')}
            error={errors['realLocation']}
            name='realLocation'
            handleBlur={event =>
              this.handleValidate(
                'realLocation',
                property.realLocation,
                errors
              )}
          />
        </CustomGrid>
      </CustomCardContainer>
    )
  }

  moreInfoCard () {
    const { t } = this.props
    const { property, errors } = this.state
    return (
      <CustomCardContainer title={t('More Info')}>
        <CustomGrid noPadLeft noPadRight noPadTop>
          <Textarea
            required
            title={t('Description')}
            handleChange={event => this.handleChange(event, 'description')}
            value={property.description}
            placeholder={t('Insert the property description')}
            error={errors['description']}
            name='description'
            handleBlur={event =>
              this.handleValidate('description', property.description, errors)}
          />
        </CustomGrid>
        <CustomHalf noPadLeft>
          <Input
            title={t('Lead')}
            handleChange={event => this.handleChange(event, 'lead')}
            value={property.lead}
            placeholder={t('Insert the property lead')}
          />
        </CustomHalf>
        <CustomHalf noPadRight>
          <Input
            required
            title={t('Estimated Yield (%)')}
            handleChange={event => this.handleChange(event, 'yield')}
            value={`${property.yield}`}
            placeholder={t('Estimated Yield')}
            error={errors['yield']}
            name='yield'
            handleBlur={event =>
              this.handleValidate('yield', property.yield, errors)}
          />
        </CustomHalf>

        <CustomHalf noPadLeft>
          <Input
            required
            title={t('Number of Keys')}
            handleChange={event => this.handleChange(event, 'noRooms')}
            value={`${property.noRooms}`}
            placeholder={t('Insert Number of Keys')}
            error={errors['noRooms']}
            name='noRooms'
            handleBlur={event =>
              this.handleValidate('noRooms', property.noRooms, errors)}
          />
        </CustomHalf>
      </CustomCardContainer>
    )
  }

  imageCard () {
    const { t } = this.props
    const { property, errors } = this.state
    return (
      <CustomCardContainer title={t('Images')}>
        <CustomHalf noPadLeft noPadTop>
          <span>{t('Do you want to use the pre-defined city image?')}</span>
        </CustomHalf>
        <CustomHalf noPadRight noPadTop>
          <Switch
            className='switch'
            active={property.useDefaultPictures}
            onClick={() => this.handleSwitch('useDefaultPictures')}
          />
        </CustomHalf>
        <CustomGrid noPadLeft noPadRight>
          {property.picture ? (
            <Avatar
              size={136}
              buttonClass={'edit-button'}
              imageSrc={property.picture.result || property.picture}
              onEdit={this.uploadPicture}
              handleError={this.handleUploadImageError}
              error={errors['imageUpload']}
            />
          ) : (
            <UploadPicture
              handleUploaded={this.uploadPicture}
              uploadButton={
                <UploadButton>
                  <Add />
                  {t('Import picture')}
                </UploadButton>
              }
              handleError={this.handleUploadImageError}
              error={errors['imageUpload']}
            />
          )}
        </CustomGrid>
      </CustomCardContainer>
    )
  }

  permissionsCard () {
    const { t } = this.props
    const {
      property,
      searchUsersToAdd,
      searchUsersToRemove,
      searchedUsers,
      authorizedUsers
    } = this.state
    return (
      <CustomCardContainer title={t('Permissions')}>
        <CustomGrid noPadLeft noPadRight>
          <CustomHalf noPadLeft noPadTop>
            <Title>{t('Permissions')}</Title>
            <span>{t('Is this property available for everyone?')}</span>
          </CustomHalf>
          <CustomHalf noPadRight noPadTop>
            <Switch
              className='switch'
              active={property.fullAccess}
              onClick={() => this.handleSwitch('fullAccess')}
            />
          </CustomHalf>
        </CustomGrid>
        {!property.fullAccess ? (
          <CustomGrid noPadLeft noPadTop>
            <CustomHalf noPadLeft>
              <UserSearchBox>
                <Input
                  title={t('Unauthorized')}
                  handleChange={this.handleSearchUser}
                  placeholder={t('Search for users')}
                  value={searchUsersToAdd}
                />
                <CustomList>
                  {searchedUsers.map((el, index) => {
                    return (
                      <ListItem
                        odd={index % 2 === 0}
                        key={`user-to-add-${index}`}
                        onClick={() => this.handleSelectUser(el)}>
                        {el.firstName} {el.lastName}
                      </ListItem>
                    )
                  })}
                </CustomList>
              </UserSearchBox>
            </CustomHalf>
            <CustomHalf noPadRight>
              <UserSearchBox>
                <Input
                  title={t('Authorized')}
                  handleChange={this.filterUsers}
                  placeholder={t('Search for users')}
                  value={searchUsersToRemove}
                />
                <CustomList>
                  {authorizedUsers.map((el, index) => {
                    return (
                      <ListItem
                        odd={index % 2 === 0}
                        key={`user-to-remove-${index}`}
                        onClick={() => this.handleSelectUser(el)}>
                        {el.firstName} {el.lastName}
                      </ListItem>
                    )
                  })}
                </CustomList>
              </UserSearchBox>
            </CustomHalf>
          </CustomGrid>
        ) : null}
        <CustomGrid noPadLeft noPadRight>
          <CustomHalf noPadLeft>
            <Title>{t('Publish Property')}</Title>
            <span>{t('Do you want to publish this property?')}</span>
          </CustomHalf>
          <CustomHalf noPadRight>
            <Switch
              className='switch'
              active={property.published}
              onClick={() => this.handleSwitch('published')}
            />
          </CustomHalf>
        </CustomGrid>
        <CustomGrid noPadLeft noPadRight>
          <CustomHalf noPadLeft>
            <Title>{t('Available Property')}</Title>
            <span>{t('Is this property sold?')}</span>
          </CustomHalf>
          <CustomHalf noPadRight>
            <Switch
              className='switch'
              active={property.sold}
              onClick={() => this.handleSwitch('sold')}
            />
          </CustomHalf>
        </CustomGrid>
      </CustomCardContainer>
    )
  }

  render () {
    const { t, router, admin, dropdownLinks } = this.props
    const { property, create, modalType, modalMessage } = this.state
    const actions = [
      { label: t('Save'), primary: true, onClick: this.handleSubmit }
    ]
    if (!create) {
      actions.push({
        label: t('Delete Property'),
        cancel: true,
        onClick: () => this.toggleModal({ type: 'dialog' })
      })
    }

    return (
      <section>
        <AdminNavbar
          admin={admin}
          dropdownLinks={dropdownLinks}
          rightSideActions={actions}
        />

        <DialogModal
          visible={modalType === 'dialog'}
          message={
            modalMessage ? (
              t(modalMessage)
            ) : (
              t('Are you sure that you want to delete this property?')
            )
          }
          closeAction={this.toggleModal}
          header={t('Delete Property')}
          buttons={{
            apply: { label: t('Delete'), onClick: this.handleDelete },
            cancel: { label: t('Cancel'), onClick: this.toggleModal }
          }}
        />
        <SuccessModal
          visible={modalType === 'success'}
          message={
            modalMessage ? (
              t(modalMessage)
            ) : (
              t(`Property successfully ${create ? 'created' : 'updated'}`)
            )
          }
          closeAction={this.toggleModal}
          header={t(`Property ${create ? 'Created' : 'Updated'}`)}
        />
        <ErrorModal
          visible={modalType === 'error'}
          message={
            modalMessage ? (
              t(modalMessage)
            ) : (
              t(
                `There was a problem when ${create
                  ? 'creating'
                  : 'updating'} the property`
              )
            )
          }
          closeAction={this.toggleModal}
          header={t('Error')}
        />
        {property && (
          <CustomThemeContainer>
            <BackArrowContainer>
              <BackArrow onClick={() => router.goBack()} />
              <span>{create ? t('Insert Property') : property.title}</span>
            </BackArrowContainer>
            {this.mainInfoCard()}
            {this.addressCard()}
            {this.moreInfoCard()}
            {this.imageCard()}
            {this.permissionsCard()}
          </CustomThemeContainer>
        )}
      </section>
    )
  }
}

AdminPropertyDetails.propTypes = {
  t: PropTypes.func,
  params: PropTypes.object,
  router: PropTypes.object,
  location: PropTypes.object,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin', 'forms' ], { wait: true })(
  AdminPropertyDetails
)



// WEBPACK FOOTER //
// ./src/pages/AdminProperties/AdminPropertyDetails.js